angular.module('zc.commonApi')

.factory 'ProjectSegmentCookie', ($resource, $q, BaseProjectCrudService) ->
  class ProjectSegmentCookie extends BaseProjectCrudService

  new ProjectSegmentCookie(
    $resource
    $q
    '/api/projects/:projectId/segment_cookies/:id'
    'segment_cookie'
    'segment_cookies'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/segment_cookie.service.coffee